import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../../../layout/Navbar";
import Footer from "../../../layout/Footer";
import CastableSuper from "../../../assets/Our Products/MonolithicCastable/CASTABLE-SUPER.jpg";
import WhiteHeatA from "../../../assets/Our Products/MonolithicCastable/WHITE-HEAT-A.jpg";
import WhiteHeatC from "../../../assets/Our Products/MonolithicCastable/WHITE-HEAT-C.jpg";
import WhiteHeatK from "../../../assets/Our Products/MonolithicCastable/WHITE-HEAT-K.jpg";
import LCC60 from "../../../assets/Our Products/MonolithicCastable/LCC-60.jpg";
import LCC90 from "../../../assets/Our Products/MonolithicCastable/LCC-90.jpg";
import Insulyte7 from "../../../assets/Our Products/MonolithicCastable/INSULYTE-7.jpg";
import Insulyte11 from "../../../assets/Our Products/MonolithicCastable/INSULYTE-11.jpg";
import RammingMass from "../../../assets/Our Products/MonolithicCastable/RAMMING-MASS.jpg";

const products = [
    {
        name: "Castable Super",
        image: CastableSuper,
        path: "/products/castable_super"
    },
    {
        name: "White Heat-A",
        image: WhiteHeatA,
        path: "/products/white_heat-a"
    },
    {
        name: "White Heat-C",
        image: WhiteHeatC,
        path: "/products/white_heat-c"
    },
    {
        name: "White Heat-K",
        image: WhiteHeatK,
        path: "/products/white_heat-k"
    },
    {
        name: "LCC-60",
        image: LCC60,
        path: "/products/lcc-60"
    },
    {
        name: "LCC-90",
        image: LCC90,
        path: "/products/lcc-90"
    },
    {
        name: "Insulyte-7",
        image: Insulyte7,
        path: "/products/insulyte-7"
    },
    {
        name: "Insulyte-11",
        image: Insulyte11,
        path: "/products/insulyte-11"
    },
    {
        name: "Ramming Mass",
        image: RammingMass,
        path: "/products/ramming_mass"
    },
];

const Castable_Monolithics = () => {
    return (
        <div className="min-h-screen bg-gray-50">
            <Navbar />
            {/* Products Section */}
            <section className="py-12 sm:py-16 lg:py-20 bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-8 sm:mb-12">
                        CASTABLE <span className="text-orange-500">MONOLITHICS</span>
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
                        {products.map((product, index) => (
                            <div
                                key={index}
                                className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-transform transform hover:-translate-y-2 overflow-hidden animate-fadeInUp"
                                style={{ animationDelay: `${index * 0.1}s` }}
                            >
                                <div className="w-full h-56 flex items-center justify-center bg-white">
                                    <img
                                        src={product.image}
                                        alt={product.name}
                                        className="max-h-full max-w-full object-contain"
                                    />
                                </div>
                                <div className="p-6">
                                    <h3 className="text-lg sm:text-xl lg:text-2xl font-semibold text-gray-800 mb-4">
                                        {product.name}
                                    </h3>
                                    <Link
                                        to={product.path}
                                        className="px-4 py-2 bg-gradient-to-r from-yellow-500 to-orange-500 text-white rounded-lg hover:from-yellow-600 hover:to-orange-600 transition-all">
                                        Learn More
                                    </Link>
                                </div>
                            </div>

                        ))}
                    </div>
                </div>
            </section>

            <style jsx>{`
                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                .animate-fadeInUp {
                    animation: fadeInUp 0.8s ease-out forwards;
                    opacity: 0;
                }
            `}</style>
            <Footer />
        </div>
    );
};

export default Castable_Monolithics;